/* VendPeptides — centralized checkout redirect.
   Store A (this storefront) never checks out itself. Every purchase action builds a
   Shopify cart permalink on the checkout store:  {domain}/cart/{variantB}:{qty},...
   Variant IDs are mapped A -> B in snippets/vp-variant-map.liquid (window.VP_MAP),
   with a SKU fallback (window.VP_SKU_MAP) for SKUs that are unique in the catalogue. */
(function () {
  'use strict';
  var cfg  = window.VP_CHECKOUT || {},
      host = String(cfg.domain || '').replace(/\/+$/, ''),
      MAP  = window.VP_MAP || {},
      SKU  = window.VP_SKU_MAP || {};

  function resolve(items) {
    var parts = [], missing = [];
    items.forEach(function (i) {
      var b = MAP[String(i.id)] || (i.sku && SKU[i.sku]);
      if (b) parts.push(b + ':' + (parseInt(i.quantity, 10) || 1));
      else missing.push(i.title || ('variant ' + i.id));
    });
    return { parts: parts, missing: missing };
  }

  function checkoutUrl(items) {
    var r = resolve(items);
    if (!host) { console.error('[vp-checkout] no checkout domain configured'); return null; }
    if (r.missing.length) {
      alert('These items cannot be checked out right now:\n\n' + r.missing.join('\n') +
            '\n\nPlease remove them from your cart or contact support.');
      return null;
    }
    if (!r.parts.length) return null;
    var qs = [];
    if (cfg.attribution) qs.push('attributes%5Bstorefront%5D=' + encodeURIComponent(cfg.attribution),
                                 'ref=' + encodeURIComponent(cfg.attribution));
    var code = discountCode();
    if (code) qs.push('discount=' + encodeURIComponent(code));
    return host + '/cart/' + r.parts.join(',') + (qs.length ? '?' + qs.join('&') : '');
  }

  /* Discount code typed in the drawer or cart page travels to the checkout store as ?discount= */
  function discountCode() {
    var v = '';
    document.querySelectorAll('[data-vp-discount]').forEach(function (i) { if (i.value.trim()) v = i.value.trim(); });
    if (!v) { try { v = localStorage.getItem('vp_discount') || ''; } catch (e) {} }
    return v.replace(/[^A-Za-z0-9_\-]/g, '').toUpperCase().slice(0, 40);
  }
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-vp-discount]')) return;
    try { localStorage.setItem('vp_discount', e.target.value.trim()); } catch (err) {}
    document.querySelectorAll('[data-vp-discount]').forEach(function (i) { if (i !== e.target) i.value = e.target.value; });
  });
  document.addEventListener('DOMContentLoaded', function () {
    var saved = ''; try { saved = localStorage.getItem('vp_discount') || ''; } catch (e) {}
    if (saved) document.querySelectorAll('[data-vp-discount]').forEach(function (i) { if (!i.value) i.value = saved; });
  });

  function go(items, btn) {
    var url = checkoutUrl(items);
    if (!url) return;
    if (btn) { btn.disabled = true; btn.setAttribute('data-vp-label', btn.textContent); btn.textContent = 'Redirecting…'; }
    window.location.href = url;
  }

  function cartCheckout(btn) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        go(cart.items.map(function (i) {
          return { id: i.variant_id, quantity: i.quantity, sku: i.sku, title: i.product_title + (i.variant_title && i.variant_title !== 'Default Title' ? ' — ' + i.variant_title : '') };
        }), btn);
      })
      .catch(function (e) { console.error('[vp-checkout]', e); });
  }

  /* Buy now on product page: selected tier -> straight to checkout store */
  document.addEventListener('click', function (e) {
    var buy = e.target.closest('[data-vp-buy]');
    if (buy) {
      e.preventDefault();
      var form = buy.closest('form') || document.querySelector('[data-atc-form]');
      if (!form) return;
      var sel = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]'),
          qty = form.querySelector('[name="quantity"]');
      if (!sel || !sel.value) return;
      go([{ id: sel.value, quantity: qty ? qty.value : 1, sku: sel.getAttribute('data-sku') || '' }], buy);
      return;
    }
    var co = e.target.closest('[data-vp-checkout]');
    if (co) { e.preventDefault(); cartCheckout(co); return; }
    var a = e.target.closest('a[href]');
    if (a && /\/checkout(\/|\?|$)/.test(a.getAttribute('href') || '')) { e.preventDefault(); cartCheckout(null); }
  });

  /* Belt and braces: any legacy cart form submitted with a "checkout" button is intercepted */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !/\/cart\/?$/.test(f.getAttribute('action') || '')) return;
    var s = e.submitter;
    if (s && s.name === 'checkout') { e.preventDefault(); cartCheckout(s); }
  }, true);

  /* Keep Buy now in step with tier availability */
  document.querySelectorAll('[data-tiers]').forEach(function (root) {
    var buy = document.querySelector('[data-vp-buy]');
    if (!buy) return;
    var qty = document.querySelector('[data-vp-qty]');
    function sync() {
      var on = root.querySelector('input:checked');
      buy.disabled = !on || on.getAttribute('data-available') !== 'true';
      if (qty && on) {
        var max = parseInt(on.getAttribute('data-max') || '99', 10) || 99;
        qty.max = max; if (parseInt(qty.value, 10) > max) qty.value = max;
      }
    }
    root.addEventListener('change', sync); sync();
  });
})();
